const TABLE_CONFIG_STORAGE_PREFIXES = ["data-table:", "editable-table:"];

const shouldPreserveKey = (key) => (
    typeof key === "string"
    && TABLE_CONFIG_STORAGE_PREFIXES.some((prefix) => key.startsWith(prefix))
);

export const clearLocalStorageExceptTableConfigs = () => {
    if (typeof window === "undefined" || typeof window.localStorage === "undefined") {
        return;
    }

    const keysToRemove = [];
    for (let index = 0; index < window.localStorage.length; index += 1) {
        const key = window.localStorage.key(index);
        if (!shouldPreserveKey(key)) {
            keysToRemove.push(key);
        }
    }

    keysToRemove.forEach((key) => {
        if (typeof key === "string") {
            window.localStorage.removeItem(key);
        }
    });
};

